import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card-slider.component.html'
})
export class CardSliderComponent {
  public cardList: Array<any> = [{
    cardId: 'sample1',
    cardNo: '1',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Number of sessions',
    UpgradDigit: '1244',
    downGradeDigit: '3.1%',
    selectedText: 'selected',
    selected: true,
    img:'../../assets/images/banner.png'
  },
  {
    cardId: 'sample2',
    cardNo: '2',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Last login',
    selectedText: 'selected',
    img:'../../assets/images/image-1.png'
  },
  {
    cardId: 'sample3',
    cardNo: '3',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Teacher time on platform',
    UpgradDigit: '125h',
    downGradeDigit: '3.1%',
    selectedText: 'selected',
    img:'../../assets/images/image-2.png'
  },
  {
    cardId: 'sample4',
    cardNo: '4',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Total assessment and homework assigned',
    UpgradDigit: '374',
    downGradeDigit: '3.3%',
    selectedText: 'selected',
     img:'../../assets/images/image-3.png'
  },
  {
    cardId: 'sample5',
    cardNo: '5',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Course completion',
    UpgradDigit: '81%',
    downGradeDigit: '5.2%',
    selectedText: 'selected',
    img:'../../assets/images/image-4.png'
  },
  {
    cardId: 'sample6',
    cardNo: '6',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Average assessment and homework assigned',
    UpgradDigit: '6',
    downGradeDigit: '5.2%',
    selectedText: 'selected',
     img:'../../assets/images/image-5.png'
  },
  {
    cardId: 'sample7',
    cardNo: '7',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Average assessment and homework assigned',
    UpgradDigit: '6',
    downGradeDigit: '5.2%',
    selectedText: 'selected',
     img:'../../assets/images/image-6.png'
  }];

  public cardList1: Array<any> = [{
    cardId: 'sample1',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Number of sessions',
    UpgradDigit: '1244',
    downGradeDigit: '3.1%',
    selectedText: 'selected'
  },
  {
    cardId: 'sample2',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Last login'
  },
  {
    cardId: 'sample3',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Teacher time on platform',
    UpgradDigit: '125h',
    downGradeDigit: '3.1%',
    selectedText: 'selected'
  }];

  public cardList2: Array<any> = [{
    cardId: 'sample1',
    cardNo: '1',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Number of sessions',
    UpgradDigit: '1244',
    downGradeDigit: '3.1%'
  },
  {
    cardId: 'sample2',
    cardNo: '2',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Last login'
  }];

  public mobileCardList: Array<any> = [{
    cardId: 'sample1',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Number of sessions',
    UpgradDigit: '1244',
    downGradeDigit: '3.1%',
    selectedText: 'selected'
  },
  {
    cardId: 'sample2',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Last login'
  },
  {
    cardId: 'sample3',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Teacher time on platform',
    UpgradDigit: '125h',
    downGradeDigit: '3.1%',
    selectedText: 'selected'
  },
  {
    cardId: 'sample4',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Total assessment and homework assigned',
    UpgradDigit: '374',
    downGradeDigit: '3.3%',
    selectedText: 'selected'
  },
  {
    cardId: 'sample5',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Course completion',
    UpgradDigit: '81%',
    downGradeDigit: '5.2%',
    selectedText: 'selected'
  },];

  public cardList5: Array<any> = [{
    cardId: 'sample1',
    name: 'Magenta',
    hasIcon: true,
    tooltipMessage: 'Info Icon',
    topText: 'Number of sessions',
    UpgradDigit: '1244',
    downGradeDigit: '3.1%'
  }]
  isBrowser = true  as boolean;
  isMobileView = false as boolean;
  useCase = '';
  selectedUseCase = 'Arrow buttons with disable mode';
  useCases: string[] = [
    'Arrow buttons with disable mode',
    'Arrow buttons with hide mode',   
    'Card Slider with 3 cards',
    'Card Slider with 2 Fluid cards',
    'Card Slider with upper navigating buttons',
    'Card Slider with single card',
    'Card Slider with lower navigating buttons',
    'Card Slider with gradient colors',
    'Cards carousel',
    'Cards carousel with single card scroll',
    'Cards carousel with fadeIn/fadeOut'
  ];

   cards = [
    { title: 'Card 1', description: 'First card.', iconUrl: '../../assets/images/mme_logo.svg'},
    { title: 'Card 2', description: 'Second card.',  iconUrl: '../../assets/images/language-hub.svg' },
    { title: 'Card 3', description: 'Third card.',  iconUrl: '../../assets/images/mme_logo.svg' },
    { title: 'Card 4', description: 'Fourth card.',  iconUrl: '../../assets/images/mme_logo.svg' },
    { title: 'Card 5', description: 'Fifth card.',  iconUrl: '../../assets/images/dummy-logo.svg' },
    { title: 'Card 6', description: 'Sixth card.',  iconUrl: '../../assets/images/mme_logo.svg' },
    { title: 'Card 7', description: 'First card.',  iconUrl: '../../assets/images/mme_logo.svg' },
    { title: 'Card 8', description: 'Second card.',  iconUrl: '../../assets/images/mme_logo.svg' },
    { title: 'Card 9', description: 'Third card.', iconUrl: '../../assets/images/language-hub.svg' },
    { title: 'Card 10', description: 'Fourth card.', iconUrl: '../../assets/images/stars-2-on.svg' },
    { title: 'Card 11', description: 'Fifth card.', iconUrl: '../../assets/images/yx8h6prm3pfpcppq53wa.png' },
    { title: 'Card 12', description: 'Sixth card.', iconUrl: '../../assets/images/dummy-logo.svg' }
  ];

  constructor( @Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
    if( this.isBrowser){
      const windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
      this.isMobileView = windowWidth < 500;
    }
   }
   @HostListener('window:resize', ['$event'])
   onResize(event) {
     if (isPlatformBrowser(this.isBrowser)) {
       if (event.target.innerWidth < 500) {
         this.isMobileView = true;
       } else {
         this.isMobileView = false;
       }
     }
   }
  cardClickEvent(selectedCard, value) {
    if (this.isMobileView) {
      this.mobileCardList.forEach((obj) => {
        if (obj.cardId === selectedCard.cardId) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
      });
    } else{
      if (value === 'useCase1' || value === 'useCase2') {
        this.cardList.forEach((obj) => {
          if (obj.cardId === selectedCard.cardId) {
            obj.selected = true;
          } else {
            obj.selected = false;
          }
        });
      }
      else if (value === 'useCase3') {
        this.cardList1.forEach((obj) => {
          if (obj.cardId === selectedCard.cardId) {
            obj.selected = true;
          } else {
            obj.selected = false;
          }
        });
      } else if (value === 'useCase4') {
        this.cardList2.forEach((obj) => {
          if (obj.cardId === selectedCard.cardId) {
            obj.selected = true;
          } else {
            obj.selected = false;
          }
        });
      }
    }

  }
}